import { Indicator } from '../../../Common/Charts/Indicator';
import { useVaccinationChartsDataContext } from './hooks/useVaccinationChartsDataContext';

export const VaccinatedKidsUnderOneYearWithVIP = () => {
    const { chartData } = useVaccinationChartsDataContext();

    return (
        <Indicator
            title={'Crianças de 1 ano vacinadas com vacina Poliomielite Inativada'}
            indicatorValue={chartData?.indicators?.vaccinatedKidsUnderOneYearWithVIP}
            height={300}
        />
    );
};
